import "./ToastContaier.scss"

const ToastContaier = (props) => {
    return (
        <div className="toast-container">
            {props.children}
        </div>
    )
}

export default ToastContaier